var _g, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _path1, _path10, _path11, _circle5, _circle6, _path12, _circle7, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat55(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 126,
    viewBox: "0 0 191 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_49969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2382 4.09931C48.1972 1.47557 51.7381 0.599273 54.2382 0.0993072C56.7383 -0.400659 63.7381 1.09925 65.7382 2.09931C67.7383 3.09936 69.2373 10.0994 74.2373 11.5994C79.2373 13.0994 169.736 10.5994 172.737 10.5994C175.738 10.5994 180.237 14.7799 180.237 18.0994V28.5994C180.237 32.5994 180.237 35.5993 177.237 37.0994C172.737 39.3494 172.889 40.1721 171.237 42.0994C169.585 44.0267 169.635 44.6335 170.238 47.0993C171.138 50.7822 173.701 52.2816 176.237 55.0994C180.738 60.0994 181.903 61.1722 183.737 66.0994C186.002 72.1823 186.714 76.1086 186.737 82.5994C186.761 89.284 185.671 92.5923 182.738 98.5994C179.402 105.434 174.907 109.444 168.238 113.099C163.689 115.593 160.426 115.599 155.237 115.599C147.237 115.599 143.771 115.18 136.238 113.099C131.118 111.685 128.395 110.371 123.238 109.099C111.237 106.139 78.8726 107.493 72.2373 108.599C69.2373 109.099 61.2373 112.109 56.7373 114.099C51.3801 116.469 46.2373 117.599 40.2373 117.599C34.3083 117.599 29.2373 116.099 26.7373 115.099C24.2373 114.099 17.7373 110.099 16.2373 108.599C14.7373 107.099 9.30564 100.63 7.23817 94.5993C5.05194 88.2221 3.82334 84.328 4.23817 77.5993C4.69412 70.2037 5.94373 65.6376 10.2382 59.5993C13.6875 54.7493 16.5625 52.5374 21.7382 49.5993C28.7396 45.6249 37.7373 46.5994 41.7382 44.5993C45.8305 42.5536 47.2799 39.7342 49.2382 35.5993C51.5194 30.7826 52.9955 24.833 51.2382 22.0993L46.7382 15.0993C43.4642 10.7823 42.2792 6.72304 45.2382 4.09931Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.149 27.1144C129.745 29.537 124.877 30.9656 119.853 28.7295C110.626 27.008 103.702 24.8936 103.5 23.8842C103.298 22.8747 106.124 22.6729 106.124 22.6729H111.172L120.458 22.8747L126.313 22.6729C129.221 23.4717 130.553 24.6917 130.149 27.1144Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5218 82.8356L44.5501 79.8073L53.0293 56.9941L48.184 55.7828L49.5972 50.5337C49.5972 50.5337 50.8085 46.2943 50.4048 45.4866C50.001 44.6789 46.4692 50.6849 44.5501 58.0035L46.7708 59.6186L39.7048 81.2204L41.5218 82.8356Z",
    fill: "#003E60",
    stroke: "#003E60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8648 43.0635L57.5898 40.6358L55.2497 39.9834L54.6441 41.0446L52.4233 42.8616L49.7988 52.5521L51.8176 53.5616L53.8365 46.6974L55.2497 46.0918L56.8648 43.0635Z",
    fill: "#797979",
    stroke: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 44.752 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 71.8047 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7993 57.1959L33.4465 105.043M68.3729 88.8921L15.0748 72.5393M25.7748 59.6185L59.0861 103.832M65.5465 68.5015L16.6899 93.5355M36.6767 55.3789L46.9729 106.86M59.4899 60.0223L23.3522 102.015M14.6711 83.2393L69.7861 77.9902",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.585 53.5614L120.458 56.3878L121.468 52.552C121.826 51.6625 121.824 51.2105 121.266 50.5331L118.44 49.3218C116.479 49.0574 115.477 49.1813 113.796 49.7255L112.585 53.5614Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8732 25.3035L61.8304 25.9559C61.8304 25.9559 64.2859 22.4225 63.9307 19.8463C63.8079 18.9558 63.6372 18.4685 63.325 17.6255C62.0451 14.1687 54.1663 12.8348 57.0665 10.5595C57.4282 10.2757 57.7916 10.3151 58.076 9.95384C58.8758 8.93782 56.8648 7.32942 56.0572 6.72376C55.2496 6.1181 53.2379 4.43606 52.8269 5.71422C52.5749 6.49783 53.7164 6.96044 53.4326 7.73309C53.2966 8.10312 53.0304 8.20301 52.8269 8.54064C52.0843 9.77287 51.4949 10.9327 52.2213 12.1746C52.7402 13.0619 53.5869 13.0172 54.442 13.5878C55.8981 14.5595 56.8262 14.9865 58.076 16.2123C59.5286 17.6371 60.781 18.4431 61.1043 20.452C61.433 22.4952 59.8732 25.3035 59.8732 25.3035Z",
    fill: "#797979",
    stroke: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.778 46.8995L113.998 47.5052L119.651 28.7297L117.229 28.3259L111.778 46.8995Z",
    fill: "#003E60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.172 46.8995L114.402 47.707L112.181 53.7636L120.459 56.5901L120.055 58.2052L152.963 77.7882L154.981 80.8165L151.953 80.6146L119.247 60.8297L111.374 86.2674L113.998 86.8731L114.806 84.6523L150.54 81.2202V84.0466L118.036 87.4787L117.027 87.8825L116.421 95.3523L102.087 91.9202L101.078 88.8919L81.4947 71.5297L70.3909 55.3787L60.4985 38.2184L59.2871 37.6127L58.2777 40.641L54.8456 39.2278L58.8834 25.4995L62.5173 26.7108V28.7297C71.9136 49.3692 76.9877 58.0072 85.5324 66.0787C92.7459 69.1193 96.8804 70.0375 104.51 69.5108L111.172 46.8995Z",
    fill: "#003E60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.778 46.8995L113.998 47.5052L119.651 28.7297L117.229 28.3259L111.778 46.8995Z",
    stroke: "#003E60"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.172 46.8995L114.402 47.707L112.181 53.7636L120.459 56.5901L120.055 58.2052L152.963 77.7882L154.981 80.8165L151.953 80.6146L119.247 60.8297L111.374 86.2674L113.998 86.8731L114.806 84.6523L150.54 81.2202V84.0466L118.036 87.4787L117.027 87.8825L116.421 95.3523L102.087 91.9202L101.078 88.8919L81.4947 71.5297L70.3909 55.3787L60.4985 38.2184L59.2871 37.6127L58.2777 40.641L54.8456 39.2278L58.8834 25.4995L62.5173 26.7108V28.7297C71.9136 49.3692 76.9877 58.0072 85.5324 66.0787C92.7459 69.1193 96.8804 70.0375 104.51 69.5108L111.172 46.8995Z",
    stroke: "#003E60"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 181.227 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 154.174 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.221 57.1959L142.868 105.043M177.795 88.8921L124.497 72.5393M135.197 59.6185L168.508 103.832M174.968 68.5015L126.112 93.5355M146.099 55.3789L156.395 106.86M168.912 60.0223L132.774 102.015M124.093 83.2393L179.208 77.9902",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.876 79.2011L151.348 78.3936L151.55 83.2388L100.472 93.9388",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.115 81.2201L103.298 84.6522L104.106 86.0654L108.144 86.873L107.74 88.69L103.904 87.8824L102.895 89.2956L103.096 92.9296H101.279V89.6994L98.8568 88.8918L96.0304 90.305L95.4247 88.69L98.2511 87.2767L98.453 85.6617L95.8285 83.0371L96.8379 81.6239L99.8662 84.2484L101.481 83.8447L103.298 80.4126L105.115 81.2201Z",
    fill: "black",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27736,
    cy: 8.27736,
    r: 6.77736,
    transform: "matrix(-1 0 0 1 109.759 78.3936)",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 3.23019,
    transform: "matrix(-1 0 0 1 104.51 83.6426)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4249 101.61L101.482 89.0935L102.289 86.6708L100.472 85.8633L98.6551 88.6897L92.8004 101.61H90.1759V103.629L91.1853 105.043H97.04L98.2513 104.033V101.61H95.4249Z",
    fill: "black",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81698,
    cy: 1.81698,
    r: 1.81698,
    transform: "matrix(-1 0 0 1 55.6543 4.09961)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.625 20.875H152.688V32.125H138.625V20.875Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.625 15.25C137.133 15.25 135.702 15.8426 134.648 16.8975C133.593 17.9524 133 19.3832 133 20.875V32.125C133 33.6168 133.593 35.0476 134.648 36.1025C135.702 37.1574 137.133 37.75 138.625 37.75H166.75C168.242 37.75 169.673 37.1574 170.727 36.1025C171.782 35.0476 172.375 33.6168 172.375 32.125V20.875C172.375 19.3832 171.782 17.9524 170.727 16.8975C169.673 15.8426 168.242 15.25 166.75 15.25H138.625ZM166.75 18.0625C167.496 18.0625 168.211 18.3588 168.739 18.8863C169.266 19.4137 169.562 20.1291 169.562 20.875V32.125C169.562 32.8709 169.266 33.5863 168.739 34.1137C168.211 34.6412 167.496 34.9375 166.75 34.9375H138.625C137.879 34.9375 137.164 34.6412 136.636 34.1137C136.109 33.5863 135.812 32.8709 135.812 32.125V20.875C135.812 20.1291 136.109 19.4137 136.636 18.8863C137.164 18.3588 137.879 18.0625 138.625 18.0625H166.75ZM178 26.5C178 27.6189 177.556 28.6919 176.764 29.4831C175.973 30.2743 174.9 30.7188 173.781 30.7188V22.2812C174.9 22.2812 175.973 22.7257 176.764 23.5169C177.556 24.3081 178 25.3811 178 26.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_49969",
    x: 0.158203,
    y: 0,
    width: 190.579,
    height: 125.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_49969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_49969",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat55);
export default __webpack_public_path__ + "static/media/bat_55.77232343d46b722676fb773481f18189.svg";
export { ForwardRef as ReactComponent };